import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useQuery as useMilestonesQuery } from "@faire/web-api--source/api/user/milestones/userToken/list/get-hooks";
import { IGetUserMilestonesResponse } from "@faire/web-api--source/indigofair/data/IGetUserMilestonesResponse";
import { getUser } from "../serialized-data/getUser";
import { getUserMilestones } from "../serialized-data/getUserMilestones";
var getInitialMilestoneData = function getInitialMilestoneData() {
  var milestones = getUserMilestones();
  if (!milestones) {
    return undefined;
  }
  return IGetUserMilestonesResponse.build({
    milestones: milestones.reduce(function (acc, milestone) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, milestone.retailer_milestone, milestone));
    }, {})
  });
};
export var useMilestonesData = function useMilestonesData() {
  var _getUser;
  var userToken = (_getUser = getUser()) === null || _getUser === void 0 ? void 0 : _getUser.token;
  var _useMilestonesQuery = useMilestonesQuery(userToken !== null && userToken !== void 0 ? userToken : "", {
      initialData: getInitialMilestoneData(),
      enabled: !!userToken,
      staleTime: Infinity
    }),
    data = _useMilestonesQuery.data,
    isLoading = _useMilestonesQuery.isLoading;
  return {
    isLoading: isLoading,
    milestones: data === null || data === void 0 ? void 0 : data.milestones
  };
};